<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="form--login">
          <h2>Mission Control Center</h2>
          <v-snackbar
            :timeout="0"
            :top="true"
            v-model="infoError"> Login failed. Please try again.
            <v-btn flat color="pink" @click.native="infoError = false">Close</v-btn>
          </v-snackbar>
          <div :class="{'is-waiting': loader}">
            <div class="field">
              <v-text-field v-model.trim="username" class="field" name="username" placeholder="Login" required
              />
            </div>
            <div class="field">
              <v-text-field v-model.trim="password" class="field" name="password" type="password" placeholder="Password" required
                            @keyup.enter="auth"/>
            </div>
            <div>
              <v-btn flat @click="auth">Login</v-btn>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      loader: false,
      infoError: false,
      username: '',
      password: ''
    }
  },
  methods: {
    ...mapActions(['login']),
    async auth () {
      this.loader = true
      this.infoError = false

      const errorCode = await this.login({
        username: this.username,
        password: this.password
      })

      this.loader = false

      if (errorCode !== 0) {
        this.infoError = true
      }
    }
  }
}
</script>

<style>
  .form--login{
    text-align: center;
    max-width: 300px;
    margin: 0 auto;
    margin-top: 50px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue